import {DI} from '../types'
import {ContainerModule, ContainerModuleLoadOptions} from 'inversify'


import {InstrumentationService} from '@/src/infrastructure/services/monitoring/instrumentation'
import {SentryErrorReporter} from '@/src/infrastructure/services/order'

import type {IErrorReporter} from '@/src/ports/services/monitoring'
import {IInstrumentationService} from '@/src/ports/services/monitoring/instrumentation'

const initializeModule = ({bind}: ContainerModuleLoadOptions) => {
  bind<IInstrumentationService>(DI.IInstrumentationService).to(InstrumentationService)
  bind<IErrorReporter>(DI.IErrorReporter).to(SentryErrorReporter)
}

export const MonitoringModule = new ContainerModule(initializeModule)
